const loadClientScreen = () => import("./ClientScreen");

export default loadClientScreen;
